export default "__VITE_ASSET__ChuE_yGm__"